// extracted by mini-css-extract-plugin
module.exports = {"textarea":"UserApiTokenCreatedModal_textarea__2q-ab"};